/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Load(props) {
    return (
        <SvgIcon {...props}>
            <path d="M11.954,5.227L6.047,8.383l2.097,1.286C6.994,10.8,5.2,11.074,3.75,10.221 C2.9,9.721,2.297,8.918,2.045,7.958c-0.25-0.96-0.119-1.963,0.373-2.824C2.909,4.276,3.704,3.663,4.654,3.41 c0.947-0.257,1.934-0.124,2.786,0.376L7.463,3.8l0.998-1.715L8.424,2.066C7.122,1.297,5.603,1.087,4.148,1.48 C2.694,1.875,1.476,2.815,0.721,4.133c-0.757,1.319-0.96,2.858-0.578,4.332c0.388,1.479,1.319,2.713,2.62,3.479 c0.886,0.523,1.858,0.771,2.819,0.771c1.612,0,3.182-0.706,4.275-1.989l2.097,1.202V5.227z" />
        </SvgIcon>
    );
}

Load.defaultProps = {
    viewBox: '0 0 12 16'
};

export default Load;
